import { render } from "./AsSupportAuth.vue?vue&type=template&id=24c8ba9f&scoped=true&ts=true"
import script from "./AsSupportAuth.vue?vue&type=script&lang=ts"
export * from "./AsSupportAuth.vue?vue&type=script&lang=ts"

import "./AsSupportAuth.vue?vue&type=style&index=0&id=24c8ba9f&lang=scss&scoped=true"
import "./AsSupportAuth.vue?vue&type=style&index=1&id=24c8ba9f&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24c8ba9f"]])

export default __exports__